// extracted by mini-css-extract-plugin
export default {"absolute":"Confirmation_absolute__DHlC7","confirmation":"Confirmation_confirmation__-Mjy9","textBlock":"Confirmation_textBlock__NrJJZ","buttons":"Confirmation_buttons__zCRCQ"};